module.exports = __webpack_public_path__ + "img/RobertSchumanSchule.b9d904d7.png";